<div>
    <br>
    <br>
    <nb-form-field *ngIf="dataCategories" class="cat-dropdown">
        <nb-select ngDefaultControl [(ngModel)]="selectedDataCategory" [placeholder]="'category'| translation">
            <nb-option *ngFor="let category of dataCategories" [value]="category">{{category.title}}</nb-option>
        </nb-select>
    </nb-form-field>

    <nb-form-field>
        <!--NEBULAR FIX noWhiteSpace-->
        <input nbInput [placeholder]="'model_new'| translation" noWhiteSpace #newModelName="ngModel" ngDefaultControl [(ngModel)]="newModel">
    </nb-form-field>
    &nbsp;&nbsp;
    <button nbButton status="primary" (click)="createModel()" [disabled]="!selectedDataCategory || alreadyExists() || newModelName.invalid">{{'add'| translation}}</button>
</div>
<div style="color:red;" *ngIf="alreadyExists()">{{'model_already_exist'| translation}}.</div>
<div style="color:red;" *ngIf="newModelName.errors && newModelName.errors.noWhiteSpace">{{'model_no_white_space'| translation}}.
</div>